import { useEffect, useState } from 'react';
import { useTranslation } from "react-i18next";
import { Panel } from 'primereact/panel';
import { Button } from 'primereact/button';
import { InputMask } from 'primereact/inputmask';
import { Tree, TreeCheckboxSelectionKeys, TreeMultipleSelectionKeys } from 'primereact/tree';
import { useGlobalState } from '../../../components/globalState/GlobalStateProvider';
import { FilterWeb } from '../../../interface/FilterWeb';
import { Fieldset } from 'primereact/fieldset';
import { InputNumber } from 'primereact/inputnumber';
import { PickList } from 'primereact/picklist';
import { RadioButton } from 'primereact/radiobutton';
import { Divider } from 'primereact/divider';
import getFiltroPermissao from '../../../service/getFiltroPermissao';
import { validarCNPJ } from '../../../utils';
import { Dropdown } from 'primereact/dropdown';
import { InputText } from 'primereact/inputtext';
 
 
export default function FiltroPJ({
    onProcess,
    onClose,
    msgs
  }: {
    onProcess: (filterWeb : FilterWeb, automotiva: boolean) => void
    onClose: () => void,
    msgs:any
  }) {
  const { t } = useTranslation();
  const {state} = useGlobalState();
  const [cnpj, setCnpj] = useState<string>("");
  const [selectedKeys, setSelectedKeys] = useState<string | TreeMultipleSelectionKeys | TreeCheckboxSelectionKeys | any | null>(null); 
  const [selectedOptionCheck] = useState<any[]>([]);
  const [valor, setValor] = useState<number|null|undefined>(null);
  const [arrojado, setArrojado] = useState<boolean|undefined>(false);
  const [usual, setUsual] = useState<boolean|undefined>(false);
  const [conservador, setConservador] = useState<boolean|undefined>(false);
  const [targets, setTargets] = useState<any[]>([]);
  const [selectedFilter, setSelectedFilter] = useState<any>();
  const [opcionais, setOpcionais] = useState<any[]>([]);
  const [options, setOptions] = useState<any[]>([]);
  const [validDocument, setValidDocument] = useState<boolean>(false)
  const [nome, setNome] = useState<string>("");
  const [regiao, setRegiao] = useState<string|null>(null);

  const regioesTrt = [
    { name: 'Selecione', code: null },
    { name: '1', code: '1' },
    { name: '2', code: '2' },
    { name: '3', code: '3' },
    { name: '4', code: '4' },
    { name: '5', code: '5' },
    { name: '6', code: '6' },
    { name: '7', code: '7' },
    { name: '8', code: '8' },
    { name: '9', code: '9' },
    { name: '10', code: '10' },
    { name: '11', code: '11' },
    { name: '12', code: '12' },
    { name: '13', code: '13' },
    { name: '14', code: '14' },
    { name: '15', code: '15' },
    { name: '16', code: '16' },
    { name: '17', code: '17' },
    { name: '18', code: '18' },
    { name: '19', code: '19' },
    { name: '20', code: '20' },
    { name: '21', code: '21' },
    { name: '22', code: '22' },
    { name: '23', code: '23' },
    { name: '24', code: '24' }
  ];

  const mensagemErroFiltro = (mensagem : string) => {
    window.scrollTo(0, 0);
    msgs.current?.clear();
      msgs.current?.show([
          { sticky: false, life: 100000, severity: 'error', summary: 'Erro', detail: mensagem, closable: false }

      ]);
  }

  const validFiltro = (filteWeb :FilterWeb, filtro:any) => {
    if(filtro.tipoFiltro.includes("MAIS_NEGOCIO") && filtro.obrigatorio && !filteWeb.arrojado && !filteWeb.conservador && !filteWeb.usual){
      return false;
    }
    if(filtro.tipoFiltro.includes("NOME") && filtro.obrigatorio && !filteWeb.nome){
      return false;
    }
    if(filtro.tipoFiltro.includes("REGIAO_TRT") && filtro.obrigatorio && !filteWeb.regiao){
      return false;
    }
    return true;
  }

  const verifyObrigatorioMinimo = (filteWeb :FilterWeb, filtro:any, filtrosAtivos:any[]) => {
    let retorno = true;
    if(filtrosAtivos.length === 1){
      return false;
    }
    filtrosAtivos.filter((s1:any) => s1.tipoFiltro !== filtro.tipoFiltro && s1.obrigatorioMinimo ).forEach((f:any) => {
      retorno = validFiltro(filteWeb, f);
      if(retorno){
        return true;
      }
    })

    if(retorno){
      return true;
    }
    else{
      return false;
    }
  }

  // Coleta os filtros realmente carregados nos nós que foram selecionados.
  // Os filtros ficam em node.filtros (preenchidos por applyFiltros), nunca no estado `filtros`.
  const coletarFiltros = (nodes:any[]|undefined, consultas:string[], resultado:any[] = []) : any[] => {
    (nodes || []).forEach((node:any) => {
      if(node.filtros && consultas.includes(node.key)){
        node.filtros.forEach((f:any) => {
          if(!resultado.some((r:any) => r.tipoFiltro === f.tipoFiltro && r.descricao === f.descricao)){
            resultado.push(f);
          }
        });
      }
      coletarFiltros(node.children, consultas, resultado);
    });
    return resultado;
  }

  const valid = (filteWeb :FilterWeb) => {
    if(filteWeb.consultas.length === 0){
       mensagemErroFiltro('Opções de consulta obrigatório')
       return false;
    }
    let retorno = true;
    const filtrosAtivos = coletarFiltros(options, filteWeb.consultas);
    filtrosAtivos.forEach((filtro:any) => {
      if(!validFiltro(filteWeb, filtro)){
        if(!filtro.obrigatorioMinimo || !verifyObrigatorioMinimo(filteWeb, filtro, filtrosAtivos)){
          mensagemErroFiltro(filtro.descricao + ' obrigatório');
          retorno = false;
          return false;
        }
      }
    })

    return retorno;
  }

  const expandNode = (node:any, _expandedKeys:any) => {
    if (node.children && node.children.length) {
        _expandedKeys[node.key] = true;
 
        for (let child of node.children) {
            expandNode(child, _expandedKeys);
        }
    }
  };
 
  const validCnpj = (documento:string) => {
    if(validarCNPJ(documento)){
      msgs.current?.clear();
      setValidDocument(true);
    }
    else{
      window.scrollTo(0, 0);
      setValidDocument(false);
      msgs.current?.clear();
        msgs.current?.show([
            { sticky: false, life: 100000, severity: 'error', summary: 'Erro', detail: 'Documento inválido', closable: false }
          
        ]);
    }
  }
 
  const changeFilter = (value:any) => {
    getFiltroPermissao(value.key).then((data) => {
      applyFiltros(options, data, value.key)
      setSelectedKeys(null)
      value.filtros = data;
      setSelectedFilter(value);
      setOpcionais(createOptionsOpcionais(value))
    })
  }

  const applyFiltros = (options: any, filtros:any, value:string) => {
    options.forEach((item:any) => {
      if(item.key === value){
        item.filtros = filtros;
      }
      else{
        if(item.children && item.children.length > 0){
          applyFiltros(item.children, filtros, value)
        }
      }

    })
  }
 
  const createOptionsOpcionais = (opcao:any) =>{
    const option : any[] = [];
 
    if(opcao.permissoes && opcao.permissoes.length > 0){
      opcao.permissoes
      .sort( (a:any,b:any) => {
          if(!a.ordenacao){
            return 1;
          }

          if(!b.ordenacao){
            return -1;
          }

          if (a.ordenacao > b.ordenacao) {
            return 1;
          }
          if (a.ordenacao < b.ordenacao) {
            return -1;
          }
          return 0;
      } ).forEach((element: any) => {
        if(element.value === 'QUODPJINDICADORESNEGOCIO_PERFIL' ||
          element.value === 'QUODPJINDICADORESNEGOCIO_MERCADO' ||
          element.value === 'QUODPJINDICADORESNEGOCIO_GESTAO' ||
          element.value === 'QUODPJINDICADORESNEGOCIO_CENARIO' ||
          element.value === 'QUODPJINDICADORESNEGOCIO_PONTUALIDADE'){
          if(targets.filter((s)=>s.value===element.value).length === 0){
            targets.push({value : element.value, target : []})
          }

        }
        option.push({label:element.label, key:element.value, Collapse:true, pickList: targets.filter((s) => s.value === element.value).length !== 0 ? element.permissoes : undefined, children: [], permissoes:element.permissoes});
      });

      expandAll(option)
    }
    return option;
  }

  const createOptions = () =>{
    const option : any[] = [];
 
    state.user.consultas.filter((f: {
      tipoConsulta: string; 
    }) => f.tipoConsulta ===  'PJ' || f.tipoConsulta === 'PFPJ')
    .sort( (a:any,b:any) => {
        if(!a.ordenacao){
          return 1;
        }

        if(!b.ordenacao){
          return -1;
        }

        if (a.ordenacao > b.ordenacao) {
          return 1;
        }
        if (a.ordenacao < b.ordenacao) {
          return -1;
        }
        return 0;
    } )
    .forEach((element: any) => {
      const filhos = element.permissoes ? element.permissoes.filter((f: {
        tipoConsulta: string;
      }) => f.tipoConsulta ===  'PJ' || f.tipoConsulta === 'PFPJ') : [];
      if(filhos.length > 0){
        option.push({root: true, label:element.label, key:element.value, Collapse:true, children: createPermissoesFilhos(filhos, true)});
      }

     });

    expandAll(option)
    return option;
  }
 
  const buscarFiltro = (value:any) => {
    if(Object.getOwnPropertyNames(value).length > 0){
      const key = Object.getOwnPropertyNames(value)[Object.getOwnPropertyNames(value).length - 1]
      getFiltroPermissao(key).then((data) => {
        applyFiltros(opcionais, data, key)
      })
    }
    
  }
 
  const expandAll = (option:any) => {
    let _expandedKeys = {};
 
    for (let node of option) {
        expandNode(node, _expandedKeys);
    }
 
   return _expandedKeys;
};
 
  const createPermissoesFilhos = (permissoes:any[], first:boolean) => {
    const option : any[] = [];
    if(permissoes){
      permissoes
      .sort( (a:any,b:any) => {
          if(!a.ordenacao){
            return 1;
          }

          if(!b.ordenacao){
            return -1;
          }

          if (a.ordenacao > b.ordenacao) {
            return 1;
          }
          if (a.ordenacao < b.ordenacao) {
            return -1;
          }
          return 0;
      } )
      .forEach((element: {
        children: any; label: string; value: string; permissoes:any[]
      }) => {
        if(element.value === 'QUODPJINDICADORESNEGOCIO_PERFIL' ||
          element.value === 'QUODPJINDICADORESNEGOCIO_MERCADO' ||
          element.value === 'QUODPJINDICADORESNEGOCIO_GESTAO' ||
          element.value === 'QUODPJINDICADORESNEGOCIO_CENARIO' ||
          element.value === 'QUODPJINDICADORESNEGOCIO_PONTUALIDADE'){
          if(targets.filter((s)=>s.value===element.value).length === 0){
            targets.push({value : element.value, target : []})
          }

        }
        option.push({label:element.label, first: first, key:element.value, Collapse:true, pickList: targets.filter((s) => s.value === element.value).length !== 0 ? element.permissoes : undefined, children: [], permissoes:element.permissoes});
      });
    }
    return option;
  }

  const processConsulta = () => {
 
    let opcoes: string[] = [];
    if(selectedFilter){
      opcoes.push(selectedFilter.key);
    }
    
    if(selectedKeys && Object.getOwnPropertyNames(selectedKeys).length > 0){
      Object.getOwnPropertyNames(selectedKeys).map((item) => opcoes.push(item));
    }
    /* else{
      if(selectedFilter.permissoes && selectedFilter.permissoes.length > 0){
        window.scrollTo(0, 0);
        msgs.current?.clear();
          msgs.current?.show([
              { sticky: false, life: 100000, severity: 'error', summary: 'Erro', detail: 'Selecione pelo menos um opcional', closable: false }
            
          ]);
          return;
      }
    }*/
    selectedOptionCheck.map((item) => opcoes.push(item.value));
    const filteWeb :FilterWeb = {
      documento: cnpj,
      consultas: opcoes,
      valor: valor,
      arrojado: arrojado,
      usual:usual,
      conservador: conservador,
      nome: nome,
      indicadores: targets.filter((s:any) => opcoes.includes(s.value))
    };
    if(valid(filteWeb)){
      onProcess(filteWeb, !cnpj);
    }
  }
 
  useEffect(()=> {
    setOptions(createOptions())  
  },[])
 
  const clearPerfilMaisNegocio = () => {
    setArrojado(false);
    setConservador(false);
    setUsual(false);
  }
 
  const onChange = (event:any, key:string) => {
    const targetsOut = [{value: key, target: event.target}]
    targets.filter((s:any) => s.value !== key).map((item:any) => targetsOut.push(item));
    setTargets(targetsOut)
  };
 
  const pickItemTemplate = (item:any) => {
    return (
        <div className="flex flex-wrap p-2 align-items-center gap-3">
            <div className="flex-1 flex flex-column gap-2">
                <span className="font-bold">{item.label}</span>
            </div>
        </div>
    );
  };
  const nodeTemplateRadio = (node: any, options: { className: string | undefined; }) => {
    let label = <div className='grid' style={{alignItems: 'center'}}><RadioButton inputId={node.key} name="filter" value={node} onChange={(e) => changeFilter(e.value)} checked={selectedFilter?.key === node.key} />{selectedFilter?.key === node.key ? (<div style={{paddingLeft: '0.5rem'}}>{nodeTemplate(node)}</div>) : (<label htmlFor={node.key} className="ml-2">{node.label}</label>)}{node.informativo && ( <i data-pr-tooltip={node.informativo} data-pr-position="right" data-pr-at="right+5 top" style={{paddingLeft: '1.5rem', color: '#183462', fontSize: '1.2rem'}} className="custom-target-icon pi pi-question-circle"></i>)}</div>;
    if (node.children.length !== 0) {
       label = <b>{node.label}</b>;
    }
   
    return label;
  }
  const nodeTemplate = (node: any) => {
    let label = <span>{node.label}</span>;
    if (node.children.length !== 0 || node.first) {
      label = <b className={node.root ? 'root' : ''} onClick={(e)=> {if(node.root){ e.stopPropagation()}}}>{node.label}</b>;
    }
    if(node.key === 'QUODVERIFIQPJ_SCORE' && ((selectedFilter && selectedFilter.key === 'QUODVERIFIQPJ_SCORE') || (selectedKeys && Object.getOwnPropertyNames(selectedKeys)?.includes('QUODVERIFIQPJ_SCOREBOLETO')))){
      node.selectable = false
    }
    if(node.key === 'QUODVERIFIQPJ_SCORE' &&  ((selectedFilter && selectedFilter.key === 'QUODVERIFIQPJ_SCORE') || (selectedKeys && Object.getOwnPropertyNames(selectedKeys)?.includes('QUODVERIFIQPJ_SCOREBOLETO') && Object.getOwnPropertyNames(selectedKeys)?.includes('QUODVERIFIQPJ_SCORE')))){
      node.selectable = true
      delete selectedKeys.QUODVERIFIQPJ_SCOREBOLETO; 
      
    }
    if(node.key === 'QUODVERIFIQPJ_SCOREBOLETO' && ((selectedFilter && selectedFilter.key === 'QUODVERIFIQPJ_SCOREBOLETO') || (selectedKeys && Object.getOwnPropertyNames(selectedKeys)?.includes('QUODVERIFIQPJ_SCORE')))){
      node.selectable = false
    }
    let content: any = null;

    if(((selectedFilter && selectedFilter.key === node.key) || (selectedKeys && Object.getOwnPropertyNames(selectedKeys)?.includes(node.key))) && node.filtros && node.filtros.filter((s1:any) => s1.tipoFiltro === 'MAIS_NEGOCIO').length > 0){
      content = <>{content}
        {content && <br></br>}
        <div className="flex-auto">
          <label htmlFor="currency" className="font-bold block mb-2">{t('valor')}</label>
          <InputNumber inputId="currency" onValueChange={(e) => setValor(e.value)} mode="currency" currency="BRL" locale="pt-BR" />
        </div>
        <br></br>
        <label htmlFor="currency" className="font-bold block mb-2 required">{t('perfilRisco')}</label>
        <br></br>
        <div className="flex align-items-center">
          <RadioButton inputId="arrojado" name="perfil" onChange={e => {e.originalEvent?.stopPropagation(); clearPerfilMaisNegocio(); setArrojado(e.checked)}} checked={arrojado? arrojado : false}  />
          <label htmlFor="arrojado" className="ml-2">{t('arrojado')}</label>
        </div>
        <br></br>
        <div className="flex align-items-center">
          <RadioButton inputId="usual" name="perfil" onChange={e =>{e.originalEvent?.stopPropagation(); clearPerfilMaisNegocio(); setUsual(e.checked)}} checked={usual? usual : false}  />
          <label htmlFor="usual" className="ml-2">{t('usual')}</label>
        </div>
        <br></br>
        <div className="flex align-items-center">
          <RadioButton inputId="conservador" name="perfil" onChange={e =>{e.originalEvent?.stopPropagation(); clearPerfilMaisNegocio(); setConservador(e.checked)}} checked={conservador? conservador : false}  />
          <label htmlFor="conservador" className="ml-2">{t('conservador')}</label>
        </div>
      </>
    }

    if(((selectedFilter && selectedFilter.key === node.key) || (selectedKeys && Object.getOwnPropertyNames(selectedKeys)?.includes(node.key))) && node.filtros && node.filtros.filter((s1:any) => s1.tipoFiltro === 'REGIAO_TRT').length > 0){
      content = <>{content}
        {content && <br></br>}
        <div className="flex-auto">
          <label htmlFor="regiao" className="font-bold block mb-2">{t('regiao')}</label>
          <Dropdown value={regiao} onChange={(e) => setRegiao(e.value)} options={regioesTrt} optionLabel="name" placeholder="Selecione o Região" optionValue='code' className="w-full md:w-14rem" />
        </div>
      </>
    }

    if(((selectedFilter && selectedFilter.key === node.key) || (selectedKeys && Object.getOwnPropertyNames(selectedKeys)?.includes(node.key))) && node.filtros && node.filtros.filter((s1:any) => s1.tipoFiltro === 'NOME').length > 0){
      content = <>{content}
        {content && <br></br>}
        <div className="flex-auto">
          <label htmlFor="nome" className="font-bold block mb-2">{t('nome')}</label>
          <InputText id="nome" value={nome} onChange={(e) => {setNome(e.target.value); setValidDocument(true);}} placeholder="Digite Nome" />
        </div>
      </>
    }

    if((node.pickList && selectedKeys && ((selectedFilter && selectedFilter.key === node.key) || (Object.getOwnPropertyNames(selectedKeys)?.includes(node.key))))){
      content = <>{content}
        {content && <br></br>}
        <PickList dataKey="value" onChange={(e) => {onChange(e, node.key)}} itemTemplate={pickItemTemplate} showSourceControls={false} showTargetControls={false} source={node.pickList.filter((s:any) => {return targets.filter((s:any) => s.value === node.key)[0].target.filter((s2:any) => s.value === s2.value).length === 0} )} target={targets.filter((s:any) => s.value === node.key)[0].target}  filter filterBy="label"
          sourceHeader="Indicadores" targetHeader="Selecionados" sourceStyle={{ height: '24rem' }} targetStyle={{ height: '24rem' }}
          sourceFilterPlaceholder="Busca" targetFilterPlaceholder="Busca" />
      </>
    }

    if(content){
      return <Fieldset onClick={(e)=> e.stopPropagation()} legend={node.label}>{content}</Fieldset>
    }

    return label;
  }
 
  return (<>
    <Panel header={t('consultaPJ')}>
        <div className=" p-fluid flex flex-wrap gap-3">
            <div className="flex-auto">
                <label htmlFor="cnpj" className="font-bold block mb-2 required">CNPJ</label>
                <InputMask id="cnpj" value='cnpj' onBlur={(e)=>{setCnpj(e.target.value);validCnpj(e.target.value)}} mask="99.999.999/9999-99" placeholder="99.999.999/9999-99" required></InputMask>
            </div>
            <br></br>
            <div className=" p-fluid flex flex-wrap gap-3">
              <Tree filter filterMode="lenient" nodeTemplate={nodeTemplateRadio} expandIcon={undefined} collapseIcon={undefined} expandedKeys = {expandAll(createOptions())} value={options} selectionKeys={selectedKeys} onSelectionChange={(e) => {setSelectedKeys(e.value);  }} style={{border:'none', marginLeft:'-2.0rem', background:'transparent'}}  />
            </div>
            {opcionais && opcionais.length > 0 && ( 
              <div className=" p-fluid flex flex-wrap gap-3">
                <Divider className="automotiva" align="left">
                  <div className="flex-score justify-content-between justify-content-center">
                    <span
                      className="p-tag"
                      style={{
                        position: "relative",
                        backgroundColor: "#183462",
                        fontSize: "1.1rem",
                        height: "2rem",
                        
                      }}
                    >
                      Opcionais
                    </span>
                    </div>
                </Divider>
                <Tree nodeTemplate={nodeTemplate} expandIcon={undefined} collapseIcon={undefined} expandedKeys = {expandAll(opcionais)} value={opcionais} selectionMode='checkbox' selectionKeys={selectedKeys} onSelectionChange={(e) => {buscarFiltro(e.value); setSelectedKeys(e.value);  }} style={{border:'none', marginLeft:'-2.0rem', background:'transparent'}}  />
              </div>
            )}


        </div>
    </Panel>

    {/* Footer sempre visível */}
    <div style={{
      position: 'sticky',
      bottom: 0,
      backgroundColor: '#f9fafb',
      borderTop: '1px solid #ddd',
      padding: '1rem',
      display: 'flex',
      justifyContent: 'flex-end',
      boxShadow: '0 -2px 4px rgba(0,0,0,0.1)',
      marginTop: 'auto'
    }}>
        <Button disabled={!validDocument} style={{marginRight:"1rem", backgroundColor:'#183462'}} label="Consultar"  onClick={processConsulta} />
    </div>
    </>
  )
}